import { TSalesTaxFlow } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import {
  SalesTaxFilingFrequencyEnum,
  SalesTaxFilingStatusEnum,
  ServiceCategory,
  ServiceRequestStatus,
  ServiceSubcategory,
} from '@prisma/client';
import { API_BASE_PATH } from './constants';

export enum ServiceRequestExportColumn {
  Id = 'id',
  CompanyName = 'companyName',
  Customer = 'customer',
  AssignedAgentFirm = 'assignedAgentFirm',
  Assignee = 'assignee',
  Type = 'type',
  Service = 'service',
  Status = 'status',
  ComplianceName = 'complianceName',
  FiscalYear = 'fiscalYear',
  Jurisdiction = 'jurisdiction',
  FilingStatus = 'filingStatus',
  FilingFrequency = 'filingFrequency',
  TaxPeriod = 'taxPeriod',
  FirmAssignedOn = 'firmAssignedOn',
  UserAssignedOn = 'userAssignedOn',
  StartDate = 'startDate',
  DueDate = 'dueDate',
  EstimatedTax = 'estimatedTax',
}

export type ServiceRequestExportFilterConfig = {
  search?: string;
  corporationId?: number;
  companyId?: number;
  serviceRequestId?: string;
  serviceRequestIds?: string[];
  excludedServiceTypes?: TSalesTaxFlow[];
  includeServiceTypes?: TSalesTaxFlow[];
  isCommendaFiling?: boolean;
  serviceCategories?: ServiceCategory[];
  serviceSubcategories?: ServiceSubcategory[];
  serviceCompositeIds?: string[];
  excludeClientManagedFilings?: boolean;
  assignedUserId?: string;
  assignedAgentFirmUserId?: string;
  assignedAgentFirmId?: string;
  isAgentFirmAssigned?: boolean;
  includedStatuses?: ServiceRequestStatus[];
  assigned?: boolean;
  companyIds?: number[];
  // Sales Tax Registration filters
  salesTaxRegistrationStates?: string[];
  // Sales Tax Filing filters
  salesTaxFilingStates?: string[];
  dueDateStart?: string;
  dueDateEnd?: string;
  salesTaxFilingStatuses?: SalesTaxFilingStatusEnum[];
  salesTaxFilingFrequencies?: SalesTaxFilingFrequencyEnum[];
  salesTaxFilingReportingPeriodStart?: string;
  salesTaxFilingReportingPeriodEnd?: string;
  complianceTypes?: string[];
};

export type ExportServiceRequestsParams = {
  filterConfig?: ServiceRequestExportFilterConfig;
  columns?: ServiceRequestExportColumn[];
};

export async function exportServiceRequests(
  params: ExportServiceRequestsParams
): Promise<Response> {
  const res = await fetcher(
    `${API_BASE_PATH}/pagination/export`,
    {
      method: 'POST',
      body: params,
    },
    undefined,
    undefined,
  );

  return res;
}
